import { motion, useReducedMotion } from "motion/react";
import { Ziggy } from "../Ziggy";
import { SectionCard } from "../Section";
import type { ZiggyAge, ZiggyPose } from "../../lib/ziggy";
import { EASE_OUT, RESULT_ENTER } from "../../lib/motion";

/**
 * Animated result header — Ziggy + headline for quiz/practice completions.
 * Rare/first-time flow → short delight motion (Emil: celebrations may animate).
 */
export function ResultHero({
  pose,
  ziggyAge,
  title,
  subtitle,
}: {
  pose: ZiggyPose;
  ziggyAge: ZiggyAge;
  title: string;
  subtitle: string;
}) {
  const reduce = useReducedMotion();

  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y: 12, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={reduce ? { duration: 0 } : RESULT_ENTER}
    >
      <SectionCard className="flex items-center gap-4">
        <motion.div
          initial={reduce ? false : { opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={reduce ? { duration: 0 } : { ...RESULT_ENTER, delay: 0.05 }}
        >
          <Ziggy pose={pose} age={ziggyAge} size={72} alt="" className="shrink-0" />
        </motion.div>
        <div className="min-w-0">
          <p className="font-display text-lg font-semibold">{title}</p>
          <p className="text-muted-foreground mt-0.5 text-xs">{subtitle}</p>
        </div>
      </SectionCard>
    </motion.div>
  );
}

export { EASE_OUT };
